export const ventaModificarAdmin = {
  OK: 1,
  VentaNoUltimaVersion: 2,
  Error: 3,
}

export const ventaStatus = {
  OK: 1,
  Finalizado: 2,
  Cancelada: 3,
}
